// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'

import {
  KeyValueTable,
  ExpandableSection
} from '../../'

import { PayslipsUploaded } from './PayslipsUploaded'
import { PayslipsViewed } from './PayslipsViewed'


export class PayslipEngagementStats extends Component {
  state = {
    payrollCycleDate: null
  }

  setPayslipPayrollCycleDate = (date) => (
    this.setState({ payrollCycleDate: date })
  )

  render() {
    const { show, toggleShow, className, style } = this.props
    const { payrollCycleDate } = this.state

    return (
      <div className={`${show ? 'slds-p-bottom_large' : ''} ${className}`} style={style}>
        <ExpandableSection
          open={show}
          title='Payslip Engagement Stats'
          // summary={
          //   <div className='slds-grid slds-text-color_weak whatsapp-session-info-summary'>
          //     <div>Files last uploaded: <PayslipsUploaded /> </div>
          //     <div>Views via WhatsApp: (coming soon)</div>
          //   </div>
          // }
          inline={false}
          titleWidthClassName='slds-size_1-of-2'
          onClick={toggleShow}>
          <div>
            <DatePicker
              id='payrollCycleDate'
              selected={payrollCycleDate}
              placeholderText='Select payroll cycle date'
              onChange={this.setPayslipPayrollCycleDate}
              dateFormat='DD/MM/YYYY'
              minDate={moment('2021-01-28')}  // date from which stats are dependable again after file migration
              showMonthDropdown={true}
              showYearDropdown={true}
              autoComplete='off'
              className='slds-input slds-m-left_small'
            />
            {payrollCycleDate &&
              <KeyValueTable
                data={{
                  'Files successfully uploaded': <PayslipsUploaded payrollCycleDate={payrollCycleDate.toString()} />,
                  'Payslips viewed via WhatsApp': <PayslipsViewed payrollCycleDate={payrollCycleDate.toString()} />,
                  'Unique users who viewed payslips': <PayslipsViewed payrollCycleDate={payrollCycleDate.toString()} uniqueViews={true} />
                }}
                keyColumnSize='3-of-4'
                className='slds-col slds-m-top_large'
              />
            }
          </div>
        </ExpandableSection>
      </div>
    )
  }
}

PayslipEngagementStats.propTypes = {
  show: PropTypes.bool,
  toggleShow: PropTypes.func,
  className: PropTypes.string
}

PayslipEngagementStats.defaultProps = {
  show: false,
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/messageplus/dashboard-reporting/PayslipEngagementStats.js